import React, { useState } from 'react';
import classes from './style.module.scss';
import { useOutsideClickHook } from 'utils/outsideClick';
import { unitLabels } from 'utils/fields';
import classNames from 'classnames';

const getColumns = (unitOptions) => unitOptions.map(option => '1fr').join(' ');

export default ({
    unitOptions=['m'],
    selectedUnit='',
    changeSelected,
    openListBelow=false,
    highlight=false,
}) => {
    // if (unitOptions.length <= 1) {
    //     return;
    // }

    const [open, toggleOpen] = useState(false);
    const ref = useOutsideClickHook(() => toggleOpen(false));

    const selected = selectedUnit;

    return (
        <div className={classNames(classes.unitButton, {
            [classes.disabled]: unitOptions.length <= 1,
            [classes.openListBelow]: (openListBelow || highlight),
            [classes.highlight]: highlight,
        })} 
        onClick={()=>{
          toggleOpen(!open)}} 

            ref={ref}>
            <span>{unitLabels(selected)}</span>
            {unitOptions.length > 1 &&
                <ul
                    className={`${classes.unitList} ${open ? classes.open : ''}`}
                    style={{
                        gridTemplateColumns:getColumns(unitOptions),
                        display: unitOptions.includes("fraction") ? "flex" : "grid",
                    }}
                >
                    {
                        unitOptions.map(option => (
                            <li
                                key={option}
                                className={selected === option ? classes.active : ''}
                                onClick={()=>changeSelected(option)}
                            >
                                    {unitLabels(option)}
                            </li>
                        ))
                    }
                </ul>
            }
        </div>
    )
}